import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CoreCommonModule } from '../../../@core/common.module';
import { CardSnippetModule } from '../../../@core/components/card-snippet/card-snippet.module';
import { ContentHeaderModule } from '../../../app/layout/components/content-header/content-header.module';
import { NouisliderModule } from 'ng2-nouislider';
import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from 'ngx-swiper-wrapper';
import { NgSelectModule } from '@ng-select/ng-select';
import { MyApplicationComponent } from '../../../app/main/my-application/my-application.component';
import { DirectivesModule } from '../directives/directives.module';
import { ViewApplicationComponent } from './view-application/view-application.component';
import { AuthGuard, NgbDateCustomParserFormatter } from '../../auth/helpers';
import { ProgressReportComponent } from './progress-report/progress-report.component';
import { ToastrModule } from 'ngx-toastr';
import { NgApexchartsModule } from 'ng-apexcharts';
import { BankMandateFormComponent } from './bank-mandate-form/bank-mandate-form.component';
import { MeetingAgendaComponent } from './meeting-agenda/meeting-agenda.component';
import { CompletionReportComponent } from './completion-report/completion-report.component';
import { Ng2FlatpickrModule } from 'ng2-flatpickr';
import { MyApplicationService } from './my-application.service';
import { DateDirective } from '../directives/date.directive';
import { DatePipe } from '@angular/common';
import { ApplicationListComponent } from './application-list/application-list.component';
import { MeetingAgendaListComponent } from './meeting-agenda-list/meeting-agenda-list.component';
import { MisReportComponent } from './mis-report/mis-report.component';
import { Role } from 'app/auth/models';
import { ExpertListComponent } from './expert-list/expert-list.component';
import { AddExpertComponent } from './add-expert/add-expert.component';
import { HydroenApplicationListComponent } from './hydroen-application-list/hydroen-application-list.component';
import { HydroenApplicationComponent } from './hydroen-application/hydroen-application.component';
import { UserListComponent } from './user-list/user-list.component';
import { ViewUserComponent } from './view-user/view-user.component';
import { CustomerListComponent } from './customer-list/customer-list.component';
import { UsersComponent } from './users/users.component';
import { ApplicationsComponent } from './applications/applications.component';
import { CoeApplicationComponent } from './coe-application/coe-application.component';
import { CoeApplicationListComponent } from './coe-application-list/coe-application-list.component';
import { ViewCoeApplicationComponent } from './view-coe-application/view-coe-application.component';
import { EuttcApplicationComponent } from './euttc-application/euttc-application.component';
import { EuttcApplicationListComponent } from './euttc-application-list/euttc-application-list.component';
import { ViewEuttcApplicationComponent } from './view-euttc-application/view-euttc-application.component';

// const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
// 	direction: 'horizontal',
// 	slidesPerView: 'auto',
// 	observer: true
// };

const routes: Routes = [
	{
		path: 'euttc-application',
		component: EuttcApplicationComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.User, Role.Admin, Role.Expert]},
	},
	{
		path: 'euttc-application/view/:id',
		component: ViewEuttcApplicationComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'view/:id'},
		canActivate: [AuthGuard],
	},
	{
		path: 'coe-application',
		component: CoeApplicationComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.User, Role.Admin, Role.Expert]},
	},
	{
		path: 'coe-application/view/:id',
		component: ViewCoeApplicationComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'view/:id'},
		canActivate: [AuthGuard],
	},

	{
		path: 'hydrogen-energy-application',
		component: HydroenApplicationComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.User, Role.Admin, Role.Expert]},
	},
	{
		path: 'hydrogen-energy-application/view/:id',
		component: ViewApplicationComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'view/:id'},
		canActivate: [AuthGuard],
	},
	{
		path: 'hydrogen-energy-application/progress-report/:id',
		component: ProgressReportComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'progress-report/:id' },
		canActivate: [AuthGuard],
	},
	{
		path: 'hydrogen-energy-application/mandate-form/:id',
		component: BankMandateFormComponent,
		data: { roles: [Role.User, Role.Admin], path: 'mandate-form/:id'},
		canActivate: [AuthGuard],
	},
	{
		path: 'hydrogen-energy-application/meeting-agenda/:id',
		component: MeetingAgendaComponent,
		data: { roles: [Role.Admin], path: 'meeting-agenda/:id' },
		canActivate: [AuthGuard],
	},
	{
		path: 'hydrogen-energy-application/completion-report/:id',
		component: CompletionReportComponent,
		data: { roles: [Role.User], path: 'completion-report/:id' },
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
	},
	{
		path: 'my-application',
		component: MyApplicationComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.User, Role.Admin, Role.Expert]},
	},
	{
		path: 'my-application/view/:id',
		component: ViewApplicationComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'view/:id'},
		canActivate: [AuthGuard],
	},
	{
		path: 'my-application/progress-report/:id',
		component: ProgressReportComponent,
		data: { roles: [Role.User, Role.Admin, Role.Expert], path: 'progress-report/:id' },
		canActivate: [AuthGuard],
	},
	{
		path: 'my-application/mandate-form/:id',
		component: BankMandateFormComponent,
		data: { roles: [Role.User, Role.Admin], path: 'mandate-form/:id'},
		canActivate: [AuthGuard],
	},
	{
		path: 'my-application/meeting-agenda/:id',
		component: MeetingAgendaComponent,
		data: { roles: [Role.Admin], path: 'meeting-agenda/:id' },
		canActivate: [AuthGuard],
	},
	{
		path: 'my-application/completion-report/:id',
		component: CompletionReportComponent,
		data: { roles: [Role.User], path: 'completion-report/:id' },
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
	},
	{
		path: 'meeting-agenda-list',
		component: MeetingAgendaListComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'mis-report',
		component: MisReportComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'expert-list',
		component: ExpertListComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'add-expert',
		component: AddExpertComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'edit-expert/:id',
		component: AddExpertComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'user-list',
		component: UserListComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'view-user/:id',
		component: ViewUserComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'customer-list',
		component: CustomerListComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'view-customer/:id',
		component: ViewUserComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'users',
		component: UsersComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
	{
		path: 'applications',
		component: ApplicationsComponent,
		canActivate: [AuthGuard],
		resolve: {
			accountSetting: MyApplicationService
		},
		data: { roles: [Role.Admin]},
	},
];

@NgModule({
	declarations: [MyApplicationComponent, ViewApplicationComponent, ProgressReportComponent, BankMandateFormComponent, 
		MeetingAgendaComponent, CompletionReportComponent, ApplicationListComponent, MeetingAgendaListComponent, MisReportComponent, ExpertListComponent,AddExpertComponent, HydroenApplicationListComponent, HydroenApplicationComponent, UserListComponent, ViewUserComponent, CustomerListComponent, UsersComponent, ApplicationsComponent, CoeApplicationComponent, CoeApplicationListComponent, ViewCoeApplicationComponent, EuttcApplicationComponent, EuttcApplicationListComponent, ViewEuttcApplicationComponent],
	imports: [RouterModule.forChild(routes), NgbModule, ContentHeaderModule, CardSnippetModule, CoreCommonModule, NouisliderModule,
		NgSelectModule, DirectivesModule, BrowserModule, FormsModule, ReactiveFormsModule, ToastrModule, NgApexchartsModule, Ng2FlatpickrModule],
	exports: [MyApplicationComponent, ViewApplicationComponent, ProgressReportComponent, BankMandateFormComponent, MeetingAgendaComponent, CompletionReportComponent,AddExpertComponent,
		DirectivesModule
	],
	providers: [
		// {
		// 	provide: SWIPER_CONFIG,
		// 	useValue: DEFAULT_SWIPER_CONFIG
		// },
		{
			provide: NgbDateParserFormatter, 
			useClass: NgbDateCustomParserFormatter,
		}
	]
})
export class MyapplicationModule { }
